import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Graphique camembert — distribution duotone */
export const ChartPieIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Tranche menthe (quart en haut à droite) */}
      <path
        d="M12 3a9 9 0 0 1 9 9h-9V3z"
        fill="var(--equiply-icon-bg)"
      />
      {/* Cercle complet */}
      <circle cx="12" cy="12" r="9" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Découpe interne */}
      <path
        d="M12 3v9h9"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
    </svg>
  ),
);
ChartPieIcon.displayName = "ChartPieIcon";
